import { nextTick, ref } from "vue";
import { useState } from "nuxt/app";
import { useThrottleFn } from "@vueuse/core";
import { EAction, EClickElement, EVariables, pushToDataLayer } from "../utils/dataLayer.js";
import useBreakpoint from "@/ui/composables/useBreakpoint";
import { isDrawerOpen } from "@/cms-ui/composables/useDrawer";
export function useHeader() {
  const HIDE_HEADER_OFFSET = 60;
  const isMobileMenuOpen = useState("isMobileMenuOpen", () => false);
  const isDesktopMenuOpen = useState("isDesktopMenuOpen", () => false);
  const desktopDrawerActiveIndex = useState("desktopDrawerActiveIndex", () => null);
  const mobileItemActiveIndex = useState("mobileItemActiveIndex", () => null);
  const desktopNavActiveIndex = useState("desktopNavActiveIndex", () => null);
  const desktopSubmenuWrapperRef = useState("wrapperRef", () => null);
  const desktopSubmenuRefs = useState("desktopSubmenuRefs", () => null);
  const isHeaderHideOnScrollingDown = ref(false);
  const { isDesktop } = useBreakpoint();
  let lastScrollPosition = 0;
  let currentScrollPosition = 0;
  const handleHeaderOnScroll = useThrottleFn(() => {
    if (isDrawerOpen.value) return;
    currentScrollPosition = document.documentElement.scrollTop;
    if (Math.abs(currentScrollPosition - lastScrollPosition) < HIDE_HEADER_OFFSET) {
      return;
    }
    isHeaderHideOnScrollingDown.value = currentScrollPosition > lastScrollPosition;
    lastScrollPosition = currentScrollPosition;
  }, 30);
  const handleHeaderOnResize = useThrottleFn(() => {
    if (isDesktop.value) {
      closeDesktopMenu();
    }
    if (!isDesktop.value) {
      closeMobileMenu();
    }
  }, 100);
  const handleBlanket = () => {
    closeMobileMenu();
    closeDesktopMenu();
  };
  const toggleDesktopDrawerMenu = (index, item) => {
    if (!isDesktopMenuOpen.value || desktopDrawerActiveIndex.value === index) {
      isDesktopMenuOpen.value = !isDesktopMenuOpen.value;
    }
    pushToDataLayer({
      [EVariables.EVENT]: "GAevent",
      [EVariables.ACTION]: EAction.CLICK,
      [EVariables.LABEL]: item.getName(),
      [EVariables.COMPONENT_NAME]: "menu",
      [EVariables.CLICK_ELEMENT]: EClickElement.TEXT
    });
    desktopDrawerActiveIndex.value = index;
    desktopNavActiveIndex.value = desktopNavActiveIndex.value === index ? null : index;
    nextTick(() => {
      if (desktopSubmenuWrapperRef.value && desktopSubmenuRefs.value) {
        const submenuElements = Array.isArray(desktopSubmenuRefs.value) ? desktopSubmenuRefs.value : [desktopSubmenuRefs.value];
        if (index >= 0 && index < submenuElements.length) {
          desktopSubmenuWrapperRef.value.style.height = `${submenuElements[index].offsetHeight}px`;
        }
      }
    });
  };
  function closeMobileMenu() {
    isDesktopMenuOpen.value = false;
    desktopDrawerActiveIndex.value = null;
    desktopNavActiveIndex.value = null;
  }
  function closeDesktopMenu() {
    isMobileMenuOpen.value = false;
    mobileItemActiveIndex.value = null;
  }
  function getTarget(item) {
    if (!item.getUrl()) {
      return "";
    }
    if (item.model?.parameters?.openInNewTab === "on") {
      return "_blank";
    }
    return "_self";
  }
  return {
    handleHeaderOnScroll,
    handleHeaderOnResize,
    handleBlanket,
    toggleDesktopDrawerMenu,
    getTarget,
    isMobileMenuOpen,
    isDesktopMenuOpen,
    isHeaderHideOnScrollingDown,
    desktopDrawerActiveIndex,
    desktopNavActiveIndex,
    mobileItemActiveIndex,
    desktopSubmenuWrapperRef,
    desktopSubmenuRefs
  };
}
